export const sheersSelect = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod" },
    { value: "I Have 28mm Rod", label: "28mm Rod" },
    { value: "I Have Standard Track", label: "Standard Track", disabled: true },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw", disabled: true },
    { value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
    { value: "I Have Track With Cord Draw", label: "ریل اتومات", disabled: true },
    { value: "I Have Motorized Track", label: "ریل برقی", disabled: true },
    { value: "I Have Others", label: "سایر" },
  ],
};

export const sheersSelect2 = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
    { value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
    { value: "I Have Standard Track", label: "Standard Track" },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { value: "I Have Motorized Track", label: "Motorized Track" },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
    { value: "I Have Standard Track", label: "ریل استاندارد" },
    { value: "I Have Track With Cord Draw", label: "ریل اتومات" },
    { value: "I Have Motorized Track", label: "ریل برقی" },
    { value: "I Have Others", label: "سایر" },
  ],
};

export const sheersSelect3 = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod" },
    { value: "I Have 28mm Rod", label: "28mm Rod" },
    { value: "I Have Standard Track", label: "Standard Track" },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { value: "I Have Motorized Track", label: "Motorized Track" },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { value: "I Have Standard Track", label: "ریل استاندارد" },
    { value: "I Have Track With Cord Draw", label: "ریل اتومات" },
    { value: "I Have Motorized Track", label: "ریل برقی" },
    { value: "I Have Others", label: "سایر" },
  ],
};
